module.exports = __webpack_public_path__ + "img/our_services_2.fc996a3d.jpg";